import * as React from 'react';
import WalmartFilterBranchRenderer from 'flow-doctor-lib/components/filters/WalmartFilterBranchRenderer';
import StyledAccordionFilterContainer from 'flow-doctor-lib/components/filters/StyledAccordionFilterContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const WalmartEnrollmentFilterRenderer = ({
  filterBranch,
  filterWidthType,
  objectTypeId,
  condensed = false
}) => {
  return /*#__PURE__*/_jsx(StyledAccordionFilterContainer, {
    condensed: condensed,
    padded: false,
    children: /*#__PURE__*/_jsx(WalmartFilterBranchRenderer, {
      objectTypeId: objectTypeId,
      filterBranch: filterBranch,
      filterWidthType: filterWidthType,
      bordered: false,
      topLevel: true
    })
  });
};
export default WalmartEnrollmentFilterRenderer;